import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export var convertTimeToSec = function convertTimeToSec(value) {
  var valueFormat = value;
  var splittedValue = _.split(value, ':');
  valueFormat = _.parseInt(splittedValue[0]) * 60 + _.parseInt(splittedValue[1]);
  return valueFormat;
};
export var checkMinMaxValue = function checkMinMaxValue(value, minValue, maxValue, defaultMinValue, defaultMaxValue, timeRange, startTime) {
  if (defaultMinValue === void 0) {
    defaultMinValue = null;
  }
  if (defaultMaxValue === void 0) {
    defaultMaxValue = null;
  }
  if (timeRange === void 0) {
    timeRange = null;
  }
  if (startTime === void 0) {
    startTime = null;
  }
  var error = false;
  if (!_.isNil(minValue) && convertTimeToSec(minValue) > convertTimeToSec(value)) {
    error = true;
    if (!_.isNil(defaultMinValue) && convertTimeToSec(defaultMinValue) <= convertTimeToSec(value)) {
      error = false;
    }
  }
  if (!_.isNil(maxValue) && convertTimeToSec(maxValue) < convertTimeToSec(value)) {
    error = true;
    if (!_.isNil(defaultMaxValue) && convertTimeToSec(defaultMaxValue) >= convertTimeToSec(value)) {
      error = false;
    }
  }
  if (!_.isNil(timeRange) && !_.isNil(startTime) && !_.isNil(defaultMaxValue) && timeRange && startTime && !_.isNil(maxValue) && convertTimeToSec(value) > convertTimeToSec(maxValue) && convertTimeToSec(value) <= convertTimeToSec(defaultMaxValue)) {
    error = true;
  }
  if (!_.isNil(timeRange) && !_.isNil(startTime) && !_.isNil(defaultMinValue) && timeRange && !startTime && !_.isNil(minValue) && convertTimeToSec(value) < convertTimeToSec(minValue) && convertTimeToSec(value) >= convertTimeToSec(defaultMinValue)) {
    error = true;
  }
  return error;
};